import React from "react";
import TemperatureDisplay from "@ui/components/temperature/TemperatureDisplay";
import { getNodeTemperatureStatus } from "@ui/components/temperature";
import { connectedNodeTileColor } from "../connectedNodeDisplay";
import { formatUtcToLocalDate, formatUtcToLocalTime, } from "@application/common/helpers/date-util";
import { useTranslation } from "react-i18next";
import { SensorType, isSensorHidden } from "@ui/utils/sensors";
import { limitReasons, worstRowStatus } from "@ui/utils/sensor-limit-status";
import { SMenu } from "@ui/components/menu/SMenu";
import { PermissionChecker, Permission } from "@utility/permission-checker";
import { hasEnvironmentReadings } from "@ui/utils/environment-readings";
import { SensorReading } from "./SensorReading";
import { DeviceStatusIndicator, TemperatureStatusChip, } from "@ui/components/grid/DeviceDetailsRow";
import { CardMenuButton, DeviceDetailsCard, } from "@ui/components/card/DeviceDetailsCard";
export const APDetailsNodeCard = ({ row, tabValue, onAction, onLogs, onSettings, }) => {
    var _a, _b, _c;
    const { t } = useTranslation(["common"]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleMenuOpen = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    const menuItems = [
        ...(PermissionChecker.hasPermission(Permission.ACCESSPOINTS_DELETE)
            ? [
                {
                    label: tabValue === "disconnected"
                        ? t("common:actions.couple")
                        : t("common:actions.disconnect"),
                    onClick: () => onAction(row),
                    color: tabValue === "disconnected" ? "success" : "error",
                },
            ]
            : []),
        {
            label: t("common:actions.logs"),
            onClick: () => onLogs(row.nodeId),
        },
        ...(PermissionChecker.hasPermission(Permission.NODES_EDIT) && onSettings
            ? [
                {
                    label: t("common:actions.settings"),
                    onClick: () => onSettings(row.id),
                },
            ]
            : []),
    ];
    // The same tiles as the table rows.
    const readingTiles = hasEnvironmentReadings(row)
        ? [
            // Shown as the main temperature instead when the internal one is switched off.
            ...(row.externalAsMain || isSensorHidden(row.disabledSensors, SensorType.ExternalTemperature)
                ? []
                : [
                    React.createElement(SensorReading, { key: "external", value: row.externalTemperature, unit: "\u00B0C", decimals: 1, tone: "external", inactive: !row.isActive, sensorType: SensorType.ExternalTemperature, sensorLabel: (_a = row.externalTooltip) !== null && _a !== void 0 ? _a : t("common:labels.externalTemperature"), statuses: row.sensorStatuses }),
                ]),
            ...(isSensorHidden(row.disabledSensors, SensorType.Humidity)
                ? []
                : [
                    React.createElement(SensorReading, { key: "humidity", value: row.humidity, unit: "%", tone: "humidity", inactive: !row.isActive, sensorType: SensorType.Humidity, sensorLabel: t("common:labels.humidity"), statuses: row.sensorStatuses }),
                ]),
        ]
        : undefined;
    return (React.createElement(DeviceDetailsCard, { tile: React.createElement(TemperatureDisplay, { width: 91, temperature: row.nodeTemperature, color: connectedNodeTileColor(row), external: row.externalAsMain, infoTooltip: row.tileInfoTooltip, leftIndicator: row.leftIndicator, rightIndicator: row.rightIndicator }), name: (_b = row.title) !== null && _b !== void 0 ? _b : row.nodeName, deviceId: (_c = row.subtitle) !== null && _c !== void 0 ? _c : row.nodeId, menu: React.createElement(React.Fragment, null,
            React.createElement(CardMenuButton, { onClick: handleMenuOpen }),
            React.createElement(SMenu, { anchorEl: anchorEl, open: Boolean(anchorEl), handleClose: () => setAnchorEl(null), menuItems: menuItems })), readingTiles: readingTiles, date: formatUtcToLocalDate(row.lastUpdate), time: formatUtcToLocalTime(row.lastUpdate), status: React.createElement(DeviceStatusIndicator, { active: row.status === "Active" }), badge: React.createElement(TemperatureStatusChip, { size: "medium", status: row.nodeTypeCode === 1
                ? "normal"
                : worstRowStatus(getNodeTemperatureStatus(row), row.sensorStatuses), reason: limitReasons(row.sensorStatuses, t) }) }));
};
